import axios from "axios";

function getDiscordWidget () {
    return axios.get('https://discord.com/api/guilds/997982082263433288/widget.json')
}

export default {
    getDiscordWidget
};